import { useEffect, useState } from 'react';
import { getPlayer } from '../../motion/registry';

/** The scoped frame's live playhead time in ms, polled at 60 ms — the same
 *  cadence TimelineTransport uses for its readout. 0 when no player. */
export function usePlayheadTime(frameId: string): number {
  const [t, setT] = useState(0);
  useEffect(() => {
    const id = setInterval(() => {
      const p = getPlayer(frameId);
      if (p) setT(p.time);
    }, 60);
    return () => clearInterval(id);
  }, [frameId]);
  return t;
}
